import { PageNavigator } from './components';
import './App.css';

function App() {
  return (
    <div className='app-container'>
      <PageNavigator/>
    </div>
  );
}

export default App;
